import { isAnchorLink } from '@sola/utils/url.js';

export const handleAnchorClick = (e: React.MouseEvent, href: string) => {
  if (isAnchorLink(href)) {
    e.preventDefault();
    const targetId = href.replace('#', '');
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const header = document.getElementsByClassName(
        'Header',
      )[0] as HTMLElement;
      const headerHeight = header ? header.offsetHeight : 0;
      const elementPosition = targetElement.offsetTop - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
      window?.history.pushState(null, '', href);
    }
  }
};
